import { Eye, FileDown, Printer, Mail, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { rupee } from "@/lib/format";

export default function InvoicePreviewDialog({ preview, onClose, onNavigate, onDownload, emailTo, setEmailTo, emailing, onSendEmail }) {
  return (
    <Dialog open={!!preview} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="invoice-preview-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight flex items-center gap-2"><Eye className="w-5 h-5 text-[#0F766E]" /> Invoice {preview?.invoice_no}</DialogTitle>
          <DialogDescription>Ready — download, print or email it without leaving this page.</DialogDescription>
        </DialogHeader>
        {preview && (
          <div className="space-y-4">
            <div className="rounded-md border border-[#E2E8F0] p-3 text-sm space-y-1">
              <div className="flex justify-between"><span className="text-[#64748B]">Customer</span><span className="font-medium">{preview.customer_name}</span></div>
              <div className="flex justify-between"><span className="text-[#64748B]">Date</span><span className="font-mono">{preview.invoice_date}</span></div>
              <div className="flex justify-between"><span className="text-[#64748B]">Tax</span><span>{preview.intra_state ? "CGST + SGST" : "IGST"} @ {preview.gst_rate}%{preview.gst_inclusive ? " (incl.)" : ""}</span></div>
              <div className="flex justify-between border-t border-[#E2E8F0] pt-1 font-semibold"><span>Grand Total</span><span className="font-mono">{rupee(preview.grand_total)}</span></div>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button onClick={() => onDownload(preview)} className="bg-[#0055FF] hover:bg-[#0040C1] text-white gap-2" data-testid="preview-download-btn"><FileDown className="w-4 h-4" /> Download PDF</Button>
              <Button variant="outline" onClick={() => onNavigate(`/invoices/${preview.id}/print?print=a5`)} className="gap-2" data-testid="preview-print-btn"><Printer className="w-4 h-4" /> Print (A5)</Button>
            </div>
            <div className="space-y-1.5 border-t border-[#E2E8F0] pt-3">
              <Label className="text-xs uppercase tracking-wide text-[#475569]">Email to customer</Label>
              <div className="flex gap-2">
                <Input type="email" value={emailTo} onChange={(e) => setEmailTo(e.target.value)} placeholder="customer@email.com" className="flex-1" data-testid="preview-email-to" />
                <Button onClick={onSendEmail} disabled={emailing} variant="outline" className="gap-2" data-testid="preview-email-btn">
                  {emailing ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />} Email
                </Button>
              </div>
              <p className="text-[11px] text-[#94A3B8]">Requires SMTP setup in Settings → Email (SMTP).</p>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
